// Scopes PAYABLE invoices for an asset-heavy carrier admin. Reads `carrier_partnerships`, not
// `shipper_partnerships`: the backfill rewrites faked rows to carrier_id + contractor_id with
// shipper_id = null, so the shipper slot would come back empty and silently narrow visibility.
//
// This is the ONLY thing scoping payable visibility — carrier_invoices select_permissions is
// `filter: {}`. So it must fail CLOSED: `{ _or: [] }` matches nothing, whereas a predicate built
// from an undefined id serializes to `{ client_id: {} }`, which Hasura treats as no constraint.
const MATCH_NOTHING = { _or: [] };

export const carrierAdminPayableScope = (client) => {
    const clientId = client?.client_id;
    if (!clientId) return MATCH_NOTHING;

    // Contractors only. The shipper side of a partnership is a counterparty, never a payee, so
    // adding it here would widen payable visibility without ever matching a legitimate invoice.
    const partnerships = Array.isArray(client?.carrier_partnerships) ? client.carrier_partnerships : [];
    const partnerIds = [
        ...partnerships.reduce((ids, partnership) => {
            const contractorId = partnership?.contractor_id;
            if (contractorId && contractorId !== clientId) ids.add(contractorId);
            return ids;
        }, new Set()),
    ];

    return {
        _or: [
            { client_id: { _eq: clientId } },
            { partner_client_id: { _eq: clientId } },
            // A linked Fulfillment Partner keeps its own book: only work run out of this Flex Center shows.
            ...(partnerIds.length ? [{ client_id: { _in: partnerIds }, flex_client_id: { _eq: clientId } }] : []),
        ],
    };
};
